import { Grid, Typography, Container, Paper, IconButton, Box, Modal, useMediaQuery, Divider,Button } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit"
import MyLodder from "../../components/ddpiloader"
import ContactUpdateDrawer from "./ContactUpdateDrawer"

import { useAppData } from "../../redux/appDataProvider"
import { useState, useEffect, useMemo } from "react"
import { useLocation } from "react-router-dom"
import tickmark from "../../assets/svg/nomine.png";

import ESignSuccess from "./EsignSuccess"
import ESignFailure from "./EsignFailure"

const UserProfile = () => {
    const isSmallScreen = useMediaQuery("(max-width : 600px)")

    const location = useLocation()
    const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    const successParam = searchParams.get("success")
    const isSuccess = successParam === "true"
    const isFailure = successParam === "false"

    const { userInfo, setUserInfo } = useAppData()

    const [modal, setModal] = useState(false)
    const [showlodder, setShowLodder] = useState(true)
    const [otpOpen, setOtpOpen] = useState(false)
    const [updateType, setUpdateType] = useState("")
    const [maskedValue, setMaskedValue] = useState("")
    const [addressModalOpen, setAddressModalOpen] = useState(false);

    const documentList = [
        "Aadhaar Card",
        "Passport",
        "Voter ID",
        "Driving License",
        "Utility Bill (Electricity/Water/Gas)",
        "Bank Statement (not older than 3 months)",
        "Rent Agreement",
    ];

    const supportEmail = "support@tradeboss.co";

    useEffect(() => {
        if (successParam) {
            setModal(true)
        }
    }, [successParam])

    useEffect(() => {
        if (userInfo?.CLIENT_ID_MAIL) {
            setShowLodder(!showlodder)
        }
    }, [userInfo?.CLIENT_ID_MAIL])

    const maskMobile = (mobile) => mobile?.slice(0, 2) + "XXXXX" + mobile?.slice(-3)
    const maskEmail = (email) => {
        const [user, domain] = email?.split("@")
        const masked = user?.slice(0, 2) + "X".repeat(user.length - 3) + user?.slice(-1)
        return `${masked}@${domain}`
    }

    const handleEditClick = (type) => {
        localStorage.setItem('updateType', type)
        setUpdateType(type === "email" ? "email" : "mobile")
        setMaskedValue(type === "email" ? maskMobile(userInfo.MOBILE_NO) : maskEmail(userInfo.CLIENT_ID_MAIL))
        setOtpOpen(true)
    }

    const handleAddressClick=()=>{
        setAddressModalOpen(true);
    }
    const handleClose = () => {
        setModal(false)
    }

    if (showlodder) {
        return <MyLodder canShow={showlodder} />
    }

    return (
        <>
        <Container sx={{ background: "#0B1420", minHeight: "100vh", py: 5 }}>
            <Paper
                elevation={3}
                sx={{
                    backgroundColor: "#0B1420",
                    borderRadius: 2,
                    padding: 4,
                    margin: isSmallScreen && "0px 20px 0px 20px"
                }}
            >
                <Typography sx={{ fontSize: '18px', color: "#F3D45E", pb: 2 }} >
                    Profile Details
                </Typography>

                <Grid container >
                    {/* Full Name */}
                    <Grid item xs={12} sx={{ py: 2 }}>
                        <Typography sx={{ fontSize: {xs: '14px', sm: '16px'}, color: "#999" }}>Full Name</Typography>
                        <Typography sx={{ fontSize: {xs: '14px', sm: '16px'} }}>{userInfo.CLIENT_NAME}</Typography>
                    </Grid>

                    {/* Gender */}
                    <Grid item xs={12} sm={6} md={4} sx={{ py: 2 }}>
                        <Typography sx={{ fontSize: {xs: '14px', sm: '16px'}, color: "#999" }}>Client ID</Typography>
                        <Typography sx={{ fontSize: {xs: '14px', sm: '16px'} }}>{userInfo.CLIENT_ID}</Typography>
                    </Grid>


                    {/* PAN */}
                    <Grid item xs={12} sm={6} md={4} sx={{ py: 2 }}>
                        <Typography sx={{ fontSize: {xs: '14px', sm: '16px'}, color: "#999" }}>PAN</Typography>
                        <Typography sx={{ fontSize: {xs: '14px', sm: '16px'} }}>{userInfo.PAN_NO}</Typography>
                    </Grid>

                    {/* DOB */}
                    <Grid item xs={12} sm={6} md={4} sx={{ py: 2 }}>
                        <Typography sx={{ fontSize: {xs: '14px', sm: '16px'}, color: "#999" }}>Date of Birth</Typography>
                        <Typography sx={{ fontSize: {xs: '14px', sm: '16px'} }}>{userInfo.BIRTH_DATE}</Typography>
                    </Grid>

                    {/* Mobile */}
                    <Grid item xs={12} sm={6} md={4} sx={{ py: 2 }}>
                        <Typography sx={{ fontSize: {xs: '14px', sm: '16px'}, color: "#999" }}>Mobile</Typography>
                        <Typography display="inline" sx={{ fontSize: {xs: '14px', sm: '16px'} }}>{maskMobile(userInfo.MOBILE_NO)}</Typography>
                        <IconButton size="small" sx={{ ml: 1 }} onClick={() => handleEditClick("mobile")}>
                            <EditIcon fontSize="small" />
                        </IconButton>
                    </Grid>

                    {/* Email */}
                    <Grid item xs={12} sm={6} md={4} sx={{ py: 2 }}>
                        <Typography sx={{ fontSize: {xs: '14px', sm: '16px'}, color: "#999" }}>Email</Typography>
                        <Typography display="inline" sx={{ fontSize: {xs: '14px', sm: '16px'} }}>{maskEmail(userInfo.CLIENT_ID_MAIL)}</Typography>
                        <IconButton size="small" sx={{ ml: 1 }} onClick={() => handleEditClick("email")}>
                            <EditIcon fontSize="small" />
                        </IconButton>
                    </Grid>

                        {/* OTP Drawer */}
                        <ContactUpdateDrawer open={otpOpen} onClose={() => setOtpOpen(false)} maskedValue={maskedValue} fieldType={updateType} userInfo={userInfo} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} sx={{ py: 2 }}>
                        <Typography sx={{ fontSize: { xs: '14px', sm: '16px' }, color: "#999" }}>Address</Typography>
                        <Typography display="inline" sx={{ fontSize: { xs: '14px', sm: '16px' } }}>{`${userInfo.CL_RESI_ADD1} ${userInfo.DISTRICT},${userInfo.STATE} - ${userInfo.PIN_CODE} `}</Typography>
                        <IconButton size="small" sx={{ ml: 1 }} onClick={() => handleAddressClick()}>
                            <EditIcon fontSize="small" />
                        </IconButton>
                    </Grid>
                </Paper>

            {(isSuccess || isFailure) && (
                <Modal open={modal} onClose={() => setModal(false)}>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: { xs: '90%', sm: '80%', md: '60%', lg: '40%' },
                            backgroundColor: '#fff',
                            outline: 'none',
                            p: { xs: 2, sm: 3, md: 4 },
                            borderRadius: '14px',
                            maxHeight: '90vh',
                            overflowY: 'auto'
                        }}
                    >
                        <Box sx={{ position: 'relative', textAlign: 'center' }}>
                            <IconButton
                                onClick={handleClose}
                                sx={{
                                    mt: isSmallScreen && 3,
                                    position: 'absolute',
                                    top: 8,
                                    right: 8,
                                    color: '#333333',
                                    background: "#e0e0e0",
                                    borderRadius: 1,
                                    '&:hover': { backgroundColor: '#d6d6d6' },
                                }}
                            >
                                <CloseIcon sx={{ fontSize: "14px" }} />
                            </IconButton>

                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 1,
                                    mt: 1,
                                    mb: 2,
                                    textAlign: 'center',
                                }}
                            >
                                <img src={tickmark} alt="success" style={{ width: 24, height: 24 }} />
                                <Typography
                                    sx={{
                                        color: '#000',
                                        fontSize: { xs: '14px', sm: '16px', md: '20px' },
                                        fontWeight: 600,
                                    }}
                                >
                                    {isSuccess ? "E-Sign successfully completed" : "E-Sign has failed."}
                                </Typography>
                            </Box>
                        </Box>

                            {isSuccess && <ESignSuccess />}
                            {isFailure && <ESignFailure />}
                        </Box>
                    </Modal>
                )}
            </Container>

            {/* Address Edit Modal */}
            <Modal
                open={addressModalOpen}
                onClose={() => setAddressModalOpen(false)}
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
                <Box sx={{
                    backgroundColor: '#fff',
                    borderRadius: '16px',
                    padding: '32px',
                    width: { xs: '90%', sm: '480px' },
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    outline: 'none',
                    boxShadow: '0px 8px 32px rgba(0,0,0,0.12)',
                }}>

                    {/* Close Button */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                        <Typography sx={{
                            fontSize: '18px',
                            fontWeight: 600,
                            color: '#1B2636',
                        }}>
                            Update Address
                        </Typography>
                        <IconButton onClick={() => setAddressModalOpen(false)} sx={{ color: '#3E3E3E' }}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    <Divider sx={{ mb: 2 }} />

                    {/* Info Text */}
                    <Typography sx={{
                       
                        fontSize: '14px',
                        color: '#3E3E3E',
                        mb: 1,
                        lineHeight: '22px',
                    }}>
                        To update your address, please send an email from your registered email ID to
                    </Typography>

                    {/* Email */}
                    <Typography sx={{
                       
                        fontSize: '14px',
                        color: '#0056D2',
                        fontWeight: 600,
                        mb: 2,
                        wordBreak: 'break-all',
                    }}>
                        {supportEmail}
                    </Typography>

                    <Typography sx={{
                        
                        fontSize: '14px',
                        color: '#3E3E3E',
                        mb: 1,
                        lineHeight: '22px',
                    }}>
                        Please attach any <strong>one</strong> of the following documents as proof of address:
                    </Typography>

                    {/* Document List */}
                    <Box sx={{
                        backgroundColor: '#F5F7FA',
                        borderRadius: '12px',
                        padding: '16px',
                        mb: 3,
                    }}>
                        {documentList.map((doc, index) => (
                            <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: index !== documentList.length - 1 ? 1.2 : 0 }}>
                                <Box sx={{
                                    width: '6px', height: '6px',
                                    borderRadius: '50%',
                                    backgroundColor: '#F3D45E',
                                    flexShrink: 0,
                                }} />
                                <Typography sx={{
                                    
                                    fontSize: '14px',
                                    color: '#3E3E3E',
                                }}>
                                    {doc}
                                </Typography>
                            </Box>
                        ))}
                    </Box>

                    {/* Copy Email Button */}
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={() => {
                            navigator.clipboard.writeText(supportEmail);
                        }}
                        sx={{
                            borderRadius: '39px',
                            backgroundColor: '#F3D45E',
                            fontSize: '14px',
                            fontWeight: 600,
                            color:"#1B2636",
                            textTransform: 'none',
                            padding: '10px',
                            '&:hover': { backgroundColor: '#F3D45E' },
                        }}
                    >
                        Copy Email Address
                    </Button>

                </Box>
            </Modal>
        </>
       

        
    )

}

export default UserProfile
